import {graphql} from 'react-relay'

export const branchExistsInBuildTypeQueryDefinition = graphql`
  query branchExistsInBuildTypeQuery($branchLocator: String!, $btLocator: String!) {
    branchExistsInBuildType(branchLocator: $branchLocator, btLocator: $btLocator)
  }
`
